import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { Column, usePagination, useSortBy, useTable } from 'react-table';
import { Link } from "react-router-dom";
import TableCSVExport from '../../../component/TableCSVExport';
import { getDefaultPageSize } from "../../../helpers/utils";
import ReactTable from "../../../component/ReactTable";
import { DATA_LOADING } from "../../../component/Constants";

function List(props: { loading: number, refresh: Function, integrations: any, isAdmin: boolean }) {
    const data = props.integrations

    const columns: Column[] = useMemo(() => [
        {
            Header: 'Name',
            accessor: 'name',
            className: 'fw-bold',
            defaultCanSort: true,
        },
        {
            Header: 'Description',
            accessor: 'desc',
            defaultCanSort: true,
        },
        {
            Header: 'Defined',
            accessor: 'isSet',
            defaultCanSort: true,
            Cell: ({ cell }) => (
                <React.Fragment>
                    <div className='form-check form-switch'>
                        <input checked={cell.row.values.isSet}
                               type="checkbox"
                               className="form-check-input"
                               disabled={true}
                               data-lpignore={true}
                        />
                    </div>
                </React.Fragment>
            )
        },
        {
            Header: 'Enabled',
            accessor: 'enabled',
            defaultCanSort: true,
            Cell: ({ cell }) => (
                <React.Fragment>
                    <div className='form-check form-switch'>
                        <input checked={cell.row.values.enabled === 'true'}
                               type="checkbox"
                               className="form-check-input"
                               disabled={true}
                               data-lpignore={true}
                        />
                    </div>
                </React.Fragment>
            )
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            className: 'actions',
            disableSortBy: true,
            headerClassName: 'actions',
            Cell: ({ cell }) => (
                    props.isAdmin ? (
                        <Link to={(cell.row.original as any).url} role="button"
                              className="btn btn-sm btn-primary">
                            <i className="fal fa-edit fa-fw"/><span>Edit</span>
                        </Link>
                    ) : null
            )
        }
    ], []);

    const tableInstance = useTable({
                columns,
                data,
                initialState: {
                    hiddenColumns: ['alertActionId', 'htmlIconCode'],
                    pageIndex: 0,
                    pageSize: getDefaultPageSize(),
                    sortBy: [{ id: 'title', desc: false }]
                }
            },
            useSortBy, usePagination);





    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize }
    } = tableInstance;

    return (
        <div className="col h-100">
            <div className="card">
                <div className="card-header">
                    <i className="fal fa-object-ungroup fa-fw" aria-hidden="true"/>
                    Integrations
                    <span className="badge bg-info" data-tooltip-id="global-tooltip" data-tooltip-content="Total alert actions count">{data.length}</span>
                    <i className="collapse-toggle" role="button" data-bs-toggle="collapse"
                       data-bs-target="#collapseAlerts" aria-expanded="false" aria-controls="collapseAlerts"/>
                </div>
                <div id="collapseAlerts" className="card-body collapse show">
                    <React.Fragment>
                        <div className="row row-cols-1 row-cols-md-2 table-search">
                            <div className="col col-md-12">
                                <TableCSVExport
                                    tableInstance={tableInstance}
                                    filename="Integrations"
                                />
                            </div>
                        </div>
                        <ReactTable
                            getTableProps={getTableProps}
                            getTableBodyProps={getTableBodyProps}
                            headerGroups={headerGroups}
                            prepareRow={prepareRow}
                            page={page}
                            canPreviousPage={canPreviousPage}
                            canNextPage={canNextPage}
                            pageOptions={pageOptions}
                            pageCount={pageCount}
                            gotoPage={gotoPage}
                            nextPage={nextPage}
                            previousPage={previousPage}
                            setPageSize={setPageSize}
                            pageIndex={pageIndex}
                            pageSize={pageSize}
                            dataLength={data.length}
                            error={''}
                            loading={props.loading === DATA_LOADING}
                        />
                    </React.Fragment>
                </div>
            </div>
        </div>
    )
}

List.propTypes = {
    refresh: PropTypes.func.isRequired,
};

export default List;
